// @tennis-matches/core/defaults/defaultState
// Central default state blueprint (used for first boot / localStorage reset).
import { DEFAULT_SETTINGS } from "../constants/defaultSettings.js";

export const defaultState = {
  schemaVersion: 1,

  app: { locale: "de-DE" },

  shared: {
    a11y: { fontSize: "m" },
    settings: DEFAULT_SETTINGS,
    billing: {
      payments: { byId: {}, order: [] },
    },
  },

  settings: {
    players: Object.fromEntries(Array.from({ length: 24 }, (_, i) => [String(i + 1), ""])),
    timerPrefs: {
      preCountdownSec: 5,
      speakLang: "de-DE",
      beepOnStart: true,
      beepOneMinute: true,
      countLast10: true,
    },
  },

  modules: {
    schleifchen: {
      tournament: {
        format: "doubles",
        rounds: 6,
        minutesPerRound: 15,
        points: { win: 2, draw: 1 },
      },
      resultRules: {
        mode: "ONE_SET_OPEN",
        gamesToWinSet: 6,
        openSetWinByGames: 2,
        setWinByGames: 1,
        mtbPointsToWin: 10,
        mtbWinByPoints: 2,
      },

      schedule: [],
      results: {},

      // Flow als State-Machine
      flow: { phase: "setup", round: 1, completedRound: 0 },

      // ui state
      ui: { round: 1, phase: "idle", completedRound: 0 },
    },

    club: {
      tournament: {
        meta: {
          kind: "clubmeisterschaft",
          name: "",
          discipline: "singles",
          category: "",
          periods: {
            overall: { startDate: "", endDate: "" },
            groups: { startDate: "", endDate: "" },
            ko: { startDate: "", endDate: "" },
          },
        },
        format: {
          /** "ko" | "groupsKo" | "swiss" */
          mode: "groupsKo",
          groupsKo: {
            groups: {
              groupCount: 4,
              seedingMode: "random",
              allowUnevenGroups: true,
            },
            qualification: {
              advancePerGroup: 2,
              includeBestThirds: 0,
            },
            ko: {
              bracketSize: 8,
              thirdPlaceMatch: false,
              consolation: "none",
            },
          },
        },
        matchRules: {
          scoring: "bo3",
          setEnd: "tb",
        },
        rounds: 6,
        minutesPerRound: 15,
        points: { win: 2, draw: 1 },
      },
      resultRules: {
        mode: "ONE_SET_OPEN",
        gamesToWinSet: 6,
        openSetWinByGames: 2,
        setWinByGames: 1,
        mtbPointsToWin: 10,
        mtbWinByPoints: 2,
      },
      players: { items: [], count: 12, names: {} },
      schedule: { phase: "setup" },
      results: { items: {} },
      flow: { phase: "setup", round: 1, completedRound: 0 },
      ui: { round: 1, phase: "idle", completedRound: 0, wizardMode: "new" },
    },
    minigames: {},
    trainerstunden: {
      people: { byId: {}, order: [] },
      sessions: { byId: {}, order: [] },
      ui: { tab: "planning", masterTab: "sessions", selectedSessionId: null, selectedPersonId: null, selectedLocationId: null, selectedWeekDate: "" },
      meta: { createdAt: 0, updatedAt: 0, v: 2 },
    },
  },

  timer: {
    remainingSec: null,
    isRunning: false,
    isPaused: false,
    mode: "round",
  },
};
